import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, Typography, Grid, Chip, Box } from '@material-ui/core';
import { fDateTimeSuffix } from '../../../utils/formatTime';
import { getRegionLabels } from '../../../utils/regions';
import useVrackApi from '../../../hooks/useVrackApi';

GeneralInfo.propTypes = {
  rackDetails: PropTypes.object
};

export default function GeneralInfo({ rackDetails }) {
  const [regionLabels, setRegionLabels] = useState({});

  const { fetchData: vrackApiForRegions } = useVrackApi('get', '/regions');

  useEffect(() => {
    vrackApiForRegions()
      .then((response) => {
        console.debug('Regions were successfully retrieved from the API');
        setRegionLabels(getRegionLabels(response));
      })
      .catch((error) => {
        console.debug(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card data-testid="general-info" sx={{ height: '100%', flex: 1 }}>
      <CardHeader title="General" />
      <CardContent sx={{ marginBottom: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Name
              </Typography>
              <Chip label={rackDetails.name} size="small" variant="outlined" color="primary" />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Provisioner
              </Typography>
              <Chip
                label={rackDetails.provisioner_username}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Team / Identity
              </Typography>
              <Chip
                label={rackDetails.provisioner_identity}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Created Date
              </Typography>
              <Chip
                label={fDateTimeSuffix(rackDetails.created_date)}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                Region
              </Typography>
              <Chip
                label={regionLabels[rackDetails.region]}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
          {rackDetails.tailNumber !== '' && (
            <Grid item xs={12} lg={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="overline" sx={{ flexShrink: 0 }}>
                  Tail Number
                </Typography>
                <Chip
                  label={rackDetails.tailNumber}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              </Box>
            </Grid>
          )}
          {rackDetails.xid !== 0 && (
            <Grid item xs={12} lg={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="overline" sx={{ flexShrink: 0 }}>
                  XID
                </Typography>
                <Chip label={rackDetails.xid} size="small" variant="outlined" color="primary" />
              </Box>
            </Grid>
          )}
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="overline" sx={{ flexShrink: 0 }}>
                System Type
              </Typography>
              <Chip
                label={rackDetails.system_type ? rackDetails.system_type : 'ife'}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
